import { colors } from "../design-system";

type SpinnerProps = {
  /** Diamètre en px. */
  size?: number;
  color?: string;
  /** Libellé lu par les lecteurs d'écran. */
  label?: string;
};

/**
 * Remplace `<ActivityIndicator>` de React Native, utilisé dans 67 endroits de
 * l'app native.
 *
 * Le natif fournissait un indicateur SYSTÈME (UIActivityIndicatorView /
 * ProgressBar). Le web n'a pas d'équivalent : il faut le dessiner. Un SVG animé
 * en CSS plutôt qu'un GIF ou un canvas — il hérite de la couleur, reste net à
 * toute densité d'écran, et l'animation est neutralisée automatiquement par la
 * règle `prefers-reduced-motion` globale (cf. index.css).
 *
 * `role="status"` fait annoncer l'attente par les lecteurs d'écran, ce que
 * `ActivityIndicator` ne faisait pas.
 */
export function Spinner({ size = 20, color = colors.gray500, label = "Chargement…" }: SpinnerProps) {
  return (
    <span role="status" aria-label={label} style={{ display: "inline-flex", lineHeight: 0 }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden
        style={{ animation: "alomain-spin 750ms linear infinite" }}
      >
        {/* Piste complète en filigrane + arc opaque : c'est le contraste entre
            les deux qui rend la rotation lisible. */}
        <circle cx="12" cy="12" r="9" stroke={color} strokeWidth="2.5" opacity="0.25" />
        <path
          d="M21 12a9 9 0 0 0-9-9"
          stroke={color}
          strokeWidth="2.5"
          strokeLinecap="round"
        />
      </svg>
    </span>
  );
}
